import { VIDEO_TYPE } from 'interfaces'
import { BulkContentPost } from 'services/compose/state'
import { STOCK_VIDEO_TYPE } from 'shared/constants'

/** A bulk post counts as a video post when it carries a video url or its content item is a (stock) video. */
export function isVideoPost(post: BulkContentPost): boolean {
  const type = post.content?.type
  return type === VIDEO_TYPE || type === STOCK_VIDEO_TYPE || Boolean(post.videoUrl)
}
